export class FeatureCheck {
  public static isIE11(): boolean {
    if (window.crypto) {
      return false;
    }
    return true;
  }
}
